<template>
  <f7-page class="page-wallet" @page:afterin="pageMounted">
    <f7-navbar :sliding="false">
      <f7-nav-left back-link="Trở lại"></f7-nav-left>
      <f7-nav-title sliding>NẠP/RÚT USDT</f7-nav-title>
      <f7-subnavbar>
        <f7-segmented raised>
          <f7-button :tab-link="`#deposit`" tab-link-active>NẠP</f7-button>
          <f7-button :tab-link="`#withdraw`">RÚT</f7-button>
          <f7-button :tab-link="`#history`">LỊCH SỬ</f7-button>
        </f7-segmented>
      </f7-subnavbar>
    </f7-navbar>
    <f7-list inset media-list class="mt-1 mb-1">
      <f7-list-item :title="user_info.wallet_balance | numeral('0,0[.]00')" :text="`Số dư USDT (~${balance_vnd}₫)`">
        <img src="../assets/images/no-avatar.png" slot="media" class="friend-avatar">
      </f7-list-item>
    </f7-list>
    <f7-row v-if="_.isEmpty(user_info.telegram)">
      <f7-col>
        <f7-card>
          <f7-card-content>
            <p>Vui lòng liên kết Telegram trước</p>
          </f7-card-content>
          <f7-card-footer>
            <f7-link @click="$f7router.navigate('/tao-ma-gioi-thieu')">Liên kết ngay</f7-link>
          </f7-card-footer>
        </f7-card>
      </f7-col>
    </f7-row>
    <f7-tabs>
      <f7-tab id="deposit" tab-active>
        <template v-if="!_.isEmpty(user_info.telegram)">
          <f7-block class="mt-0 mb-0" inset strong>
            <template v-if="usdt_platform === 'bsc20'">
              <f7-row v-if="_.isEmpty(user_info.wallet_address_bsc20_usdt)">
                <f7-col>
                  <f7-card>
                    <f7-card-content>
                      <p>Bạn chưa có ví USDT (BEP20). Bạn có muốn khởi tạo ngay bây giờ?</p>
                    </f7-card-content>
                    <f7-card-footer class="text-align-center">
                      <f7-link @click="generateWallet">Tạo ví</f7-link>
                    </f7-card-footer>
                  </f7-card>
                </f7-col>
              </f7-row>
              <template v-else>
                <h3 class="text-align-center">ĐỊA CHỈ VÍ USDT (BEP20) CỦA BẠN</h3>
                <div class="qr-box text-align-center">
                  <img :src="qr_code_bsc20" alt="Wallet Address">
                </div>
                <div class="list form-list no-margin margin-bottom-half">
                  <ul>
                    <li class="item-content item-input item-input-with-value">
                      <div class="item-inner">
                        <div class="item-input-wrap">
                          <input type="text" class="input-with-value" @focus="$event.target.select()" :value="user_info.wallet_address_bsc20_usdt"/>
                        </div>
                      </div>
                      <div class="item-media">
                        <button type="button" @click.prevent="copyWalletAddress(user_info.wallet_address_bsc20_usdt)" class="button button-44 text-color-theme margin-half">
                          <f7-icon f7="doc_on_doc"></f7-icon>
                        </button>
                      </div>
                    </li>
                  </ul>
                </div>
                <strong><u>Lưu ý:</u></strong>
                <ul>
                  <li>Chỉ chuyển <strong>USDT BEP20</strong> vào địa chỉ bên trên</li>
                  <li>USDT sẽ tự động cộng vào tài khoản ngay sau khi hệ thống nhận được</li>
                </ul>
              </template>
            </template>
            <template v-else-if="usdt_platform === 'trc20'">
              <f7-row v-if="_.isEmpty(user_info.wallet_address_trc20_usdt)">
                <f7-col>
                  <f7-card>
                    <f7-card-content>
                      <p>Bạn chưa có ví USDT (BEP20). Bạn có muốn khởi tạo ngay bây giờ?</p>
                    </f7-card-content>
                    <f7-card-footer class="text-align-center">
                      <f7-link @click="generateWallet">Tạo ví</f7-link>
                    </f7-card-footer>
                  </f7-card>
                </f7-col>
              </f7-row>
              <template v-else>
                <h3 class="text-align-center">ĐỊA CHỈ VÍ USDT CỦA BẠN</h3>
                <div class="qr-box text-align-center">
                  <img :src="qr_code" alt="Wallet Address">
                </div>
                <div class="list form-list no-margin margin-bottom-half">
                  <ul>
                    <li class="item-content item-input item-input-with-value">
                      <div class="item-inner">
                        <div class="item-input-wrap">
                          <input type="text" class="input-with-value" @focus="$event.target.select()" :value="user_info.wallet_address_trc20_usdt"/>
                        </div>
                      </div>
                      <div class="item-media">
                        <button type="button" @click.prevent="copyWalletAddress(user_info.wallet_address_trc20_usdt)" class="button button-44 text-color-theme margin-half">
                          <f7-icon f7="doc_on_doc"></f7-icon>
                        </button>
                      </div>
                    </li>
                  </ul>
                </div>
                <strong><u>Lưu ý:</u></strong>
                <ul>
                  <li>Chỉ chuyển <strong>USDT TRC20</strong> vào địa chỉ bên trên</li>
                  <li>USDT sẽ tự động cộng vào tài khoản ngay sau khi hệ thống nhận được</li>
                </ul>
              </template>
            </template>
          </f7-block>
          <f7-block strong inset class="alert-notice text-bigger mt-1" v-if="announcements.length > 0">
            <span v-html="announcements[0].content"></span>
          </f7-block>
        </template>
      </f7-tab>
      <f7-tab id="withdraw">
        <template v-if="!_.isEmpty(user_info.telegram)">
          <f7-list inset class="mt-0 mb-2">
            <f7-list-input
              label="Nền tảng"
              type="select"
              @input="form_withdraw.tx_network = $event.target.value"
            >
              <option value="BSC20">BEP20</option>
            </f7-list-input>
            <f7-list-input
                label="Địa chỉ Ví nhận USDT"
                type="text"
                placeholder="Địa chỉ Ví"
                :value="form_withdraw.tx_address"
                @input="form_withdraw.tx_address = $event.target.value"
            >
            </f7-list-input>
            <f7-list-input
                label="Số USDT muốn rút"
                type="text"
                :value="form_withdraw.amount"
                @input="form_withdraw.amount = $event.target.value"
            >
            </f7-list-input>
            <f7-list-input
                label="Mật khẩu cấp 2"
                type="password"
                placeholder="********"
                :value="form_withdraw.level2_password"
                @input="form_withdraw.level2_password = $event.target.value"
            >
            </f7-list-input>
            <f7-list-input
                label="Mã OTP"
                placeholder="Mã OTP"
                type="text"
                :value="form_withdraw.otp"
                @input="form_withdraw.otp = $event.target.value"
            >
              <template slot="content-end">
                <f7-button class="button-otp" outline @click.prevent="generateOTP">Lấy mã</f7-button>
              </template>
            </f7-list-input>
          </f7-list>
          <f7-block class="mt-0 mb-4" inset>
            <f7-button fill color="primary" @click.prevent="submitFormWithdraw">
              XÁC NHẬN
            </f7-button>
          </f7-block>
        </template>
      </f7-tab>
      <f7-tab id="history">
        <f7-block-title>LỊCH SỬ NẠP/RÚT</f7-block-title>
        <f7-list v-if="_.isEmpty(transactions)">
          <f7-list-item title="Chưa có dữ liệu"></f7-list-item>
        </f7-list>
        <f7-list v-else media-list>
          <f7-list-item v-for="(item, idx) in transactions" :key="idx" :title="`${item.amount} USDT`" :subtitle="item.comment" :after="$moment(item.created_at).format('DD/MM/YYYY HH:mm')"></f7-list-item>
        </f7-list>
      </f7-tab>
    </f7-tabs>
  </f7-page>
</template>
<style scoped>
.wallet-box {
  border        : 1px solid #000000;
  background    : rgba(0, 0, 0, 0.05);
  border-radius : 6px;
  padding       : 6px;
}
.button-otp {
  width : 110px;
}
.qr-box{
  max-width: 180px;
  margin: 6px auto;
  padding: 6px;
  border: 1px solid #E5E0E0;
  border-radius: 8px;
}
.qr-box img{
  max-width: 100%;
}
.text-bigger{
  font-size: 1rem;
}
</style>
<script>
import {mapState} from 'vuex';
import numeral from 'numeral';
import moment from "moment-timezone";

export default {
  data(){
    return {
      tab_active   :'deposit',
      usdt_platform: 'bsc20',
      transactions :[],
      form_withdraw:{
        tx_network     :'BSC20',
        tx_address     :'',
        amount         :0,
        level2_password:'',
        otp            :''
      },
      announcements: [],
    }
  },
  computed:{
    ...mapState(['user_info', 'exchange']),
    qr_code(){
      return process.env.VUE_APP_API_URL + 'misc/generate-qrcode/' + this.user_info.wallet_address_trc20_usdt;
    },
    qr_code_bsc20() {
      return process.env.VUE_APP_API_URL + 'misc/generate-qrcode/' + this.user_info.wallet_address_bsc20_usdt;
    },
    balance_vnd(){
      return numeral(this.user_info.wallet_balance * parseFloat(this.exchange.usdt_buy)).format('0,0')
    }
  },
  methods :{
    generateWallet(){
      this.$f7.preloader.show();
      this.$store.dispatch('generateWallet')
          .then(() => {
            return this.$store.dispatch('getMe');
          })
          .then(() => {
            this.$f7.preloader.hide();
          })
          .catch((err) => {
            this.$f7.preloader.hide();
            this.$f7.dialog.alert(err, 'LỖI!');
          })
    },
    getTransactions(){
      let to_date = moment();
      let from_date = to_date.clone().subtract(2, 'weeks');

      this.$store.dispatch('getTransactions', {
        unit:'usdt',
            from_date: from_date.format('YYYY-MM-DD 00:00:00'),
            to_date: to_date.format('YYYY-MM-DD 23:59:59'),
            limit: 999
      })
          .then((data) => {
            this.transactions = data.data;
          })
          .catch((err) => {
            this.$f7.dialog.alert(err, 'LỖI!');
          })
    },
    submitFormWithdraw(){
      this.$f7.preloader.show();
      this.$store.dispatch('submitWithdrawRequest', this.form_withdraw)
          .then(() => {
            this.$f7.preloader.hide();
            this.$f7.dialog.alert('Tạo yêu cầu rút tiền thành công', 'THÔNG BÁO');
          })
          .catch((err) => {
            this.$f7.preloader.hide();
            this.$f7.dialog.alert(err, 'LỖI!');
          })
    },
    copyWalletAddress(address){
      this.$copyText(address);
      this.showToastBottom('Đã copy');
    },
    showToastBottom(text){
      const self = this;
      if(!self.toastBottom){
        self.toastBottom = self.$f7.toast.create({
          text              :text,
          closeTimeout      :2000,
          position          :'bottom',
          horizontalPosition:'center'
        });
      }
      self.toastBottom.open();
    },
    generateOTP(){
      this.$f7.dialog.preloader();

      this.$store.dispatch('generateOTPwithdraw').then(() => {
        this.$f7.dialog.close();
      }).catch((err) => {
        this.$f7.dialog.close();
        this.$f7.dialog.alert(err, 'LỖI!');
      });
    },
    getAnnouncements() {
      this.$store.dispatch('getAnnouncements', {
        position: 'usdtpage',
        limit: 1
      }).then((data) => {
        this.announcements = data;
      });
    },
    pageMounted(){
      this.getTransactions();
      this.getAnnouncements();
    }
  }
};
</script>
